enum DynamicActorTypes {
  AssignedInitiator = 1,
  AssignedInitiatorManager = 2,
  AssignedPreviousActor = 3,
  SelectDynamicActors = 4
}
export default DynamicActorTypes;
